import { render } from "./TheDeviceConfigurationsContainer.vue?vue&type=template&id=2bd5f9b4"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__